import LockReport from './LockReport';

export default LockReport;
